export default {
  STRING: 'string',
  NUMBER: 'number',
  DATE: 'date',
  BOOLEAN: 'boolean',
  URL: 'url',
  NAME: 'name',
  EMAIL: 'email',
  PHONE_NUMBER: 'phone',
  COMPANY_NAME: 'company_name',
  COMPANY_TYPE: 'company_type',
  COMPANY_POSITION: 'company_position',
  COMPANY_SIZE: 'company_size',
  IDENTIFIER: 'id',
  TIMEZONE: 'timezone',
  LOCATION: 'location',
  CURRENCY: 'currency',
  GENDER: 'gender',
  BIRTHDAY: 'birthday',
  METRIC: 'metric',
  LANGUAGE: 'language',
  PLAN: 'plan',
  BIO: 'bio',
  SOCIAL: 'social',
  TWITTER: 'twitter',
  FACEBOOK: 'facebook',
  LINKEDIN: 'linkedin',
  DATA: {
    string: { name: 'Default' },
    number: { name: 'Number' },
    date: { name: 'Date' },
    boolean: { name: 'Yes/No' },
    url: { name: 'Url', subtype: 'string' },
    name: { name: 'Name', subtype: 'string' },
    email: { name: 'Email', subtype: 'string' },
    phone: { name: 'Phone', subtype: 'string' },
    company_name: { name: 'Company Name', subtype: 'string' },
    company_type: { name: 'Company Type', subtype: 'string' },
    company_position: { name: 'Job Title', subtype: 'string' },
    company_size: { name: 'Company Size', subtype: 'number' },
    id: { name: 'Identifier', subtype: 'string' },
    timezone: { name: 'Timezone', subtype: 'string' },
    location: { name: 'Location', subtype: 'string' },
    currency: { name: 'Currency', subtype: 'string' },
    gender: { name: 'Gender', subtype: 'string' },
    birthday: { name: 'Birthday', subtype: 'date' },
    metric: { name: 'Metric', subtype: 'number' },
    language: { name: 'Language', subtype: 'string' },
    plan: { name: 'Plan', subtype: 'string' },
    bio: { name: 'Bio', subtype: 'string' },
    social: { name: 'Social', subtype: 'string' },
    twitter: { name: 'Twitter', subtype: 'social' },
    facebook: { name: 'Facebook', subtype: 'social' },
    linkedin: { name: 'LinkedIn', subtype: 'social' },
  },
} as const;
